export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const GET_SUPPLIER = "GET_SUPPLIER";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const DELETE_SUPPLIER = "DELETE_SUPPLIER";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
